import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import {
	initialCompanyOutlet,
	initialCompanyOutletState,
} from "./defaultState";
import {
	FETCH_COMPANY_OUTLET_LIST_PROGRESS,
	FETCH_COMPANY_OUTLET_LIST_SUCCESS,
	FETCH_COMPANY_OUTLET_LIST_FAILED,
	FETCH_COMPANY_OUTLET_PROGRESS,
	FETCH_COMPANY_OUTLET_SUCCESS,
	FETCH_COMPANY_OUTLET_FAILED,
	CLEAR_COMPANY_OUTLET_STATE,
	FETCH_CUSTOMISED_COLUMN_PROGRESS,
	FETCH_CUSTOMISED_COLUMN_SUCCESS,
	FETCH_CUSTOMISED_COLUMN_FAILED,
} from "./companyOutletActions";
import { error_message } from "../../constants/constants";

export const companyOutletReducer = (
	state: IStoreState["companyOutlet"] = initialCompanyOutletState,
	action: any
) => {
	switch (action.type) {
		// List Actions
		case FETCH_COMPANY_OUTLET_LIST_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.list.loading = LoadState.NotLoaded;
				draftState.list.list = [];
				draftState.list.totalRecords = 0;
			});
		}

		case FETCH_COMPANY_OUTLET_LIST_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.list.loading = LoadState.Loaded;
				draftState.list.list = data;
				draftState.list.error = null;
			});
		}

		case FETCH_COMPANY_OUTLET_LIST_FAILED: {
			const { errorMessage } = action.payload;
			return produce(state, (draftState) => {
				draftState.list.loading = LoadState.Failed;
				draftState.list.error = errorMessage;
			});
		}

		// Single Company Outlet Actions
		case FETCH_COMPANY_OUTLET_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.companyOutlet.loading = LoadState.InProgress;
				draftState.companyOutlet.data = initialCompanyOutlet;
			});
		}

		case FETCH_COMPANY_OUTLET_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.companyOutlet.loading = LoadState.Loaded;
				draftState.companyOutlet.data = data;
				draftState.companyOutlet.error = null;
			});
		}

		case FETCH_COMPANY_OUTLET_FAILED: {
			return produce(state, (draftState) => {
				draftState.companyOutlet.loading = LoadState.Failed;
			});
		}

		case CLEAR_COMPANY_OUTLET_STATE: {
			return initialCompanyOutletState;
		}

		// Customised Column Actions
		case FETCH_CUSTOMISED_COLUMN_PROGRESS: {
			return produce(state, (draftState) => {
				draftState.customisedColumn.loading = LoadState.InProgress;
				draftState.customisedColumn.list = [];
			});
		}

		case FETCH_CUSTOMISED_COLUMN_SUCCESS: {
			const { data } = action.payload;
			return produce(state, (draftState) => {
				draftState.customisedColumn.loading = LoadState.Loaded;
				draftState.customisedColumn.list = data;
				draftState.customisedColumn.error = null;
			});
		}

		case FETCH_CUSTOMISED_COLUMN_FAILED: {
			return produce(state, (draftState) => {
				draftState.customisedColumn.loading = LoadState.Failed;
				draftState.customisedColumn.error = "Failed to fetch customised column data";
			});
		}

		default: {
			return state;
		}
	}
};
